<template>
	<v-card class="grid-flex-container my-0" elevation="0">
		<v-container fluid class="py-6">
			<v-row>
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<v-btn v-if="canAdd" color="primary" @click="showModal()">
					<v-icon> mdi-plus</v-icon>
					&nbsp;&nbsp;Add
				</v-btn>
			</v-row>
		</v-container>
		<v-data-table
			v-if="canView"
			hide-default-footer
			multi-sort
			dense
			fixed-header
			:search="search"
			:items="filters"
			:headers="headers"
			:disable-pagination="true"
			><template v-slot:[`item.actions`]="{ item }">
				<div class="d-flex">
					<v-spacer />
					<v-btn
						v-if="canEdit"
						class="action-btn"
						fab
						small
						icon
						elevation="1"
						color="success"
						@click="editFilter(item)"
					>
						<v-icon small> mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						v-if="canDelete"
						class="action-btn"
						fab
						small
						icon
						elevation="1"
						color="error"
						@click="deleteFilter(item)"
					>
						<v-icon small> mdi-delete</v-icon>
					</v-btn>
				</div>
			</template>
		</v-data-table>
		<inventory-form-filters-modal
			v-if="showDialog && selected"
			:showDialog="showDialog"
			:filters="filters"
			:selected="selected"
			@cancel="hideModal"
		/>
	</v-card>
</template>
<script>
import InventoryFormFiltersModal from '../formFilters/InventoryFormFiltersModal.vue';
import { InventoryFormFiltersActions } from '../../../../store/actions';
import { InventoryFormFiltersGetters } from '../../../../store/getters';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import { mapGetters } from 'vuex';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
export default {
	name: 'InventoryFormFilters',
	components: { InventoryFormFiltersModal },
	mixins: [permissionsMixin],
	data() {
		return {
			showDialog: false,
			selected: null,
			search: '',
			headers: [
				{
					text: 'Entity Name',
					value: 'Entity',
				},
				{
					text: 'Count',
					value: 'Count',
				},
				{
					sortable: false,
					text: '',
					value: 'actions',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			filters: [InventoryFormFiltersGetters.FILTERS],
			loading: [InventoryFormFiltersGetters.LOADING],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.Delete,
			]);
		},
	},
	mounted() {
		this.$store.dispatch(
			InventoryFormFiltersActions.LOAD_FILTERS,
			this.$route.params.id
		);
	},
	destroyed() {
		this.$store.dispatch(InventoryFormFiltersActions.CLEAR);
	},
	methods: {
		deleteFilter(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this item?',
			}).then((success) => {
				if (!success) return;
				this.$store.dispatch(
					InventoryFormFiltersActions.REMOVE_FILTERS,
					{
						inventoryFormId: item.InventoryFormId,
						gridViewId: item.GridViewId,
					}
				);
			});
		},
		editFilter(item) {
			item.Filters.forEach((x) => (x.IsDeleted = null));
			this.selected = JSON.parse(JSON.stringify(item));
			this.showDialog = true;
		},
		showModal() {
			this.selected = Object.assign(
				{},
				{
					EntityId: null,
					Filters: [
						{
							FieldId: null,
							Operator: null,
							Value: null,
							IsDeleted: null,
						},
					],
					InventoryFormId: this.$route.params.id,
				}
			);
			this.showDialog = true;
		},
		hideModal() {
			this.selected = null;
			this.showDialog = false;
		},
	},
};
</script>
